import { render, staticRenderFns } from "./logicBuilderWrap.vue?vue&type=template&id=50ad21f4&scoped=true"
import script from "./logicBuilderWrap.vue?vue&type=script&lang=js"
export * from "./logicBuilderWrap.vue?vue&type=script&lang=js"
import style0 from "./logicBuilderWrap.vue?vue&type=style&index=0&id=50ad21f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ad21f4",
  null
  
)

export default component.exports